<script type="text/jsx">
import { mapGetters } from 'vuex';

export default {
  name: 'vAmountLoading',
  computed: {
    ...mapGetters(['computedAmountLoading']),
  },
  render() {
    if (this.computedAmountLoading) {
      return <span class="opc-v-amount-loading">
        <i class="zm-icon-loading" />
      </span>;
    }

    return this.$slots?.default;
  },
};
</script>

<style lang="scss" scoped>
.opc-v-amount-loading {
}
</style>
